import { InjectionToken } from "@angular/core";
import { UiLanguages } from "./ui-languages";

export const SELFAI_AVALIABLE_LANGUAGES = new InjectionToken<UiLanguages[]>('selfaiAvaliableLanguagesToken', {
    factory: () => {
      return [UiLanguages.EN];
    },
    providedIn: 'root',
  });